import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/api";
import Spinner from "../../components/spinner";
import { FiClock, FiCalendar, FiActivity } from "react-icons/fi";
import { MdHistory } from "react-icons/md";
import { useParams } from "react-router-dom";

const History = () => {
  const { id } = useParams();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState("");

  const fetchHistory = async () => {
    try {
      const res = await axiosInstance.get(`/history/${id}`);
      setHistory(res.data.history);
    } catch (error) {
      console.error("Failed to fetch history", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const filteredHistory = selectedDate
    ? history.filter((item) => {
      const itemDate = new Date(item.createdAt).toDateString();
      const selected = new Date(selectedDate).toDateString();
      return itemDate === selected;
    })
    : history;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  };

  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  if (loading) return <Spinner message="Loading history" />;

  return (
    <div className="min-h-screen p-6">
      <div className="mx-auto">

        <div className="mb-8 flex items-start justify-between">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-blue-600 rounded-lg">
                <MdHistory className="w-5 h-5 text-white" />
              </div>
              <h1 className="text-xl font-bold text-slate-800">
                Activity History
              </h1>
            </div>
            <p className="text-sm text-slate-600 ml-14">
              Track all your recent activities and actions
            </p>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {filteredHistory.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-12 text-center">
            <div className="inline-flex p-4 bg-slate-100 rounded-full mb-4">
              <FiActivity className="w-8 h-8 text-slate-400" />
            </div>
            <h3 className="text-md font-semibold text-slate-800 mb-2">No History Yet</h3>
            <p className="text-slate-500">Your activity history will appear here once you start using the app.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {filteredHistory.map((item, index) => (
              <div
                key={item._id}
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-5 hover:shadow-md transition-shadow duration-200"
              >
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                      <h3 className="font-semibold text-slate-800 text-lg">
                        {item.action}
                      </h3>
                    </div>

                    {item.details && (
                      <p className="text-slate-600 mb-3 ml-4">
                        {item.details}
                      </p>
                    )}

                    <div className="flex items-center gap-4 ml-4 text-sm text-slate-500">
                      <div className="flex items-center gap-1.5">
                        <FiCalendar className="w-4 h-4" />
                        <span>{formatDate(item.createdAt)}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiClock className="w-4 h-4" />
                        <span>{formatTime(item.createdAt)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default History;